import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ICampaignExportApi } from './campaign-export-dialog.interface';

@Injectable({
  providedIn: 'root',
})
export class CampaignExportService {
  private readonly http = inject(HttpClient);

  public getCampaignExport(id: string, params?: HttpParams): Observable<ICampaignExportApi> {
    return this.http.get<ICampaignExportApi>(`/campaign-exports/${id}`, { params });
  }

  public createCampaignExport(campaignExport: ICampaignExportApi): Observable<ICampaignExportApi> {
    return this.http.post<ICampaignExportApi>('/campaign-exports', campaignExport);
  }

  public updateCampaignExport(campaignExport: ICampaignExportApi): Observable<ICampaignExportApi> {
    return this.http.put<ICampaignExportApi>(`/campaign-exports/${campaignExport.id}`, campaignExport);
  }

  public deleteCampaignExport(id: string): Observable<void> {
    return this.http.delete<void>(`/campaign-exports/${id}`);
  }
}
